import { createBearerAuthHeader as k } from "../auth-header.js";
const i = (c) => {
  const { storage: e, keyPrefix: a } = c, o = (t) => `${a}_${t}`, r = o("accessToken"), s = o("refreshToken"), n = () => e.getItem(r);
  return {
    getAccessToken: n,
    getRefreshToken: () => e.getItem(s),
    setTokens: (t) => {
      e.setItem(r, t.accessToken), e.setItem(s, t.refreshToken);
    },
    clearTokens: () => {
      e.removeItem(r), e.removeItem(s);
    },
    isAuthenticated: () => n() !== null,
    getAuthHeader: () => k(n())
  };
};
export {
  i as createAuthState
};
//# sourceMappingURL=auth-state.js.map
